// DashboardLayout.jsx
import { useState } from "react";
import Header from "../../DashBoardMenu/HeaderComponent/Header";
import SideBarMenuDashboard from "../../SideBarMenu/SideBarMenuDashbaord";
import { Outlet } from "react-router-dom";

const DashboardLayout = () => {
  const [user, setUser] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  return (
   <div className="min-h-screen flex flex-col">

  <Header user={user} />

  <SideBarMenuDashboard
    setSidebarStatus={setIsSidebarOpen}
    setUser={setUser}
  />

  <main
    className={`pb-10  transition-all duration-300
    ${isSidebarOpen ? "md:ml-[300px]" : "md:ml-[110px]"}`}
  >
    <div className="min-h-screen">
      <Outlet />
    </div>
  </main>

</div>
  );
};

export default DashboardLayout;
